import SkeletonCircle from './SkeletonCircle'
import SkeletonRectangular from './SkeletonRectangular'

export interface ISkeletonProps {
  w?: number | string
  h?: number | string
  className?: string
}
const Skeleton = () => {
  return null
}
export default Object.assign(Skeleton, {
  Rectangular: SkeletonRectangular,
  Circle: SkeletonCircle,
})
